module.exports = "td {\n  vertical-align: top; }\n\n.td_space {\n  padding-left: 2px;\n  padding-right: 2px; }\n"